// Manga preferences kept in this browser (the NSFW switch lives on the manga server instead).
// Each key has a list of allowed values so a stale or hand-edited entry falls back to the default.

export const MANGA_PREFS = {
    readDirection: { key: 'mangaReadDirection', values: ['ltr', 'rtl'], fallback: 'ltr' },
    pageFit: { key: 'mangaPageFit', values: ['height', 'width', 'original'], fallback: 'height' },
    pageTransition: { key: 'mangaPageTransition', values: ['on', 'off'], fallback: 'on' },
    preloadNext: { key: 'mangaPreloadNext', values: ['on', 'off'], fallback: 'on' },
    openFullscreen: { key: 'mangaOpenFullscreen', values: ['on', 'off'], fallback: 'off' },
    showComments: { key: 'mangaShowComments', values: ['on', 'off'], fallback: 'on' },
    catalogOrder: { key: 'mangaCatalogOrder', values: ['', 'new', 'rating', 'title'], fallback: '' },
    catalogTranslation: { key: 'mangaCatalogTranslation', values: ['all', 'ongoing', 'completed'], fallback: 'all' },
};

export const getMangaPref = (name) => {
    const pref = MANGA_PREFS[name];
    if (!pref) return undefined;
    try {
        const stored = localStorage.getItem(pref.key);
        return stored !== null && pref.values.includes(stored) ? stored : pref.fallback;
    } catch (error) {
        return pref.fallback;
    }
};

export const setMangaPref = (name, value) => {
    const pref = MANGA_PREFS[name];
    if (!pref || !pref.values.includes(value)) return;
    try {
        if (value === pref.fallback) localStorage.removeItem(pref.key);
        else localStorage.setItem(pref.key, value);
    } catch (error) {
        // Reading still works without storage.
    }
};

export const isMangaPrefOn = (name) => getMangaPref(name) === 'on';
